/* eslint-disable no-redeclare */

import { z } from 'zod';

export const EstimatedSpendingDto = z.enum(['low', 'medium', 'high']);

export type EstimatedSpendingDto = z.infer<typeof EstimatedSpendingDto>;
